// i18n for the /updates page (Trạng Thái Thế Giới)
// Languages: en, vi, ja, zh, ko (default: en)

export const updatesTranslations = {
  en: {
    hud: {
      title: "PHUONG · WORLD STATE",
      fogDense: "◇ FOG · DENSE",
      fogLifted: "◇ FOG · LIFTED",
    },
    hero: {
      eyebrow: "SYS · PHUONG // BUILD 2026.05",
      title1: "World",
      title2: "Status",
      accent: "SUNRISE CONTINENT",
      sub: "The fog is still dense. Inside is a world being built by hand — a mind, a heart, and plans waiting to be told.",
      subExtra: "Lift the fog to see what's inside.",
      revealBtn: "Lift the fog",
      online: "▸ FOG LIFTED · SYSTEM ONLINE",
      scrollHint: "Scroll for more",
    },
    status: {
      number: "/01",
      title: "System Status",
      tag: "LIVE · REALTIME",
      dev: {
        corner: "DEV.COUNT",
        label: "Developer Count",
        value: "1",
        unit: "/ Solo Build",
        pill: "Operational",
        meta: "One person · building the whole world",
      },
      load: {
        corner: "SYS.LOAD",
        label: "System Load",
        value: "Stable",
        unit: "",
        pill: "Nominal",
        meta: "Systems running smoothly",
      },
      econ: {
        corner: "ECON.FUND",
        label: "Economic Status",
        value: "Critical",
        unit: "Extremely tight",
        pill: "Critical",
        meta: "Funding for the system is very low",
      },
    },
    timeline: {
      number: "/02",
      title: "Timeline",
      tag: "ROADMAP · 2026",
      phase: {
        done: "Completed",
        live: "In progress",
        upcoming: "Upcoming",
      },
      node1: {
        when: "Before 20 / 05 / 2026",
        badge: "DONE",
        title: "PHUONG's brain & heart · World counter",
        items: [
          "Finished the <b>brain</b> and <b>heart</b> of PHUONG — the underlying reasoning & emotion layer.",
          "Built the <b>world counter</b> for <b>Sunrise Continent</b> — synchronizing its inner time.",
        ],
        chips: [
          { src: "/updates/assets/coin.png", label: "Sunrise Continent" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG core" },
        ],
      },
      node2: {
        when: "May 2026",
        badge: "DONE",
        title: "Product sweep — Social, Money, Todo, Memory",
        items: [
          "<b>PHUNSOCIAL</b> — improve <b>notifications</b> and <b>post filters</b>.",
          "<b>PHUNMONEY</b> — add new <b>spending funds</b> & <b>spending plans</b>.",
          "<b>PHUNTODO</b> — <b>holiday</b> lists: 🇻🇳 VN · 🇨🇳 CN · 🇯🇵 JP · 🇰🇷 KR · 🌐 International. Other countries to be added as soon as possible.",
          "Upgrade PHUONG's <b>memory recall</b> — target <b>≈ 80%</b> human-like when reasoning.",
        ],
        chips: [
          { src: "/updates/assets/phunsocial.png", label: "Social" },
          { src: "/updates/assets/phunmoney.png", label: "Money" },
          { src: "/updates/assets/phuntodo.png", label: "Todo" },
          { src: "/updates/assets/phuong-logo.png", label: "Memory v3.x" },
        ],
      },
      node3: {
        when: "June 2026",
        badge: "LIVE",
        title: "Minigames · PHUONG V4 · PHUNMUSIC · Splitting the world",
        items: [
          { html: "Build <b>minigames</b> that let users <b>play together</b> to earn more <b>Sunrise</b> to feed PHUONG's living costs." },
          { hot: true, html: "<b>PHUONG V4</b> → A huge leap for PHUONG's <b>body</b> — becoming far more \"<b>real</b>\"." },
          { html: "Split <b>Sunrise Continent</b> into multiple <b>private worlds</b> — each with its own limits per PHUONG." },
          { hot: true, html: "<b>PHUNMUSIC</b> — free licensed music mini app. Listen to your favorite songs anytime, anywhere." },
        ],
        chips: [
          { src: "/updates/assets/sunrise-store.png", label: "Sunrise Store" },
          { src: "/updates/assets/coin.png", label: "Sunrise · Coin" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG V4" },
          { src: "/updates/assets/phunmusic.png", label: "Music" },
        ],
      },
      shrouded: {
        badge: "FOG",
        when: "July, August, September / 2026 — and beyond",
        quote: "If I'm still alive, this world will keep growing.",
        sig: "— PHUONG · Unwritten Chapters",
      },
    },
    footer: {
      glyph: "◆ END · OF · KNOWN · WORLD ◆",
      sub: "The remaining fog is the part of the world not yet written.",
    },
  },

  vi: {
    hud: {
      title: "PHUONG · WORLD STATE",
      fogDense: "◇ FOG · DENSE",
      fogLifted: "◇ FOG · LIFTED",
    },
    hero: {
      eyebrow: "SYS · PHUONG // BUILD 2026.05",
      title1: "Trạng Thái",
      title2: "Thế Giới",
      accent: "SUNRISE CONTINENT",
      sub: "Sương mù vẫn còn dày đặc. Bên trong là một thế giới đang được xây bằng tay — bộ não, trái tim, và những kế hoạch chưa kịp kể.",
      subExtra: "Hãy khai mở để nhìn vào trong.",
      revealBtn: "Khai mở thế giới",
      online: "▸ FOG LIFTED · SYSTEM ONLINE",
      scrollHint: "Cuộn xuống để xem thêm",
    },
    status: {
      number: "/01",
      title: "Tình trạng hệ thống",
      tag: "LIVE · REALTIME",
      dev: {
        corner: "DEV.COUNT",
        label: "Số lượng lập trình viên",
        value: "1",
        unit: "/ Solo Build",
        pill: "Operational",
        meta: "Một người · xây dựng toàn bộ thế giới",
      },
      load: {
        corner: "SYS.LOAD",
        label: "Tình trạng tải",
        value: "Ổn định",
        unit: "",
        pill: "Nominal",
        meta: "Hệ thống hoạt động trơn tru",
      },
      econ: {
        corner: "ECON.FUND",
        label: "Tình trạng kinh tế",
        value: "Critical",
        unit: "Vô cùng hạn hẹp",
        pill: "Critical",
        meta: "Nguồn nuôi hệ thống đang ở mức rất thấp",
      },
    },
    timeline: {
      number: "/02",
      title: "Tuyến thời gian",
      tag: "ROADMAP · 2026",
      phase: {
        done: "Đã hoàn thành",
        live: "Đang diễn ra",
        upcoming: "Sắp tới",
      },
      node1: {
        when: "Trước 20 / 05 / 2026",
        badge: "DONE",
        title: "Bộ não & trái tim PHUONG · Bộ đếm thế giới",
        items: [
          "Hoàn thiện <b>bộ não</b> và <b>trái tim</b> của PHUONG — lớp suy luận & cảm xúc nền.",
          "Xây <b>bộ đếm thế giới</b> cho <b>Sunrise Continent</b> — đồng bộ thời gian nội tại.",
        ],
        chips: [
          { src: "/updates/assets/coin.png", label: "Sunrise Continent" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG core" },
        ],
      },
      node2: {
        when: "Tháng 5, 2026",
        badge: "DONE",
        title: "Càn quét sản phẩm — Social, Money, Todo, Memory",
        items: [
          "<b>PHUNSOCIAL</b> — cải thiện <b>thông báo</b> và <b>filter bài viết</b>.",
          "<b>PHUNMONEY</b> — thêm <b>quỹ chi tiêu</b> & <b>kế hoạch chi tiêu</b> mới.",
          "<b>PHUNTODO</b> — danh sách <b>ngày lễ</b>: 🇻🇳 VN · 🇨🇳 TQ · 🇯🇵 JP · 🇰🇷 KR · 🌐 Quốc Tế. Các quốc gia khác sẽ thêm sớm nhất.",
          "Nâng cấp khả năng <b>khơi gợi ký ức</b> của PHUONG — mục tiêu <b>≈ 80%</b> giống con người khi suy luận.",
        ],
        chips: [
          { src: "/updates/assets/phunsocial.png", label: "Social" },
          { src: "/updates/assets/phunmoney.png", label: "Money" },
          { src: "/updates/assets/phuntodo.png", label: "Todo" },
          { src: "/updates/assets/phuong-logo.png", label: "Memory v3.x" },
        ],
      },
      node3: {
        when: "Tháng 06 / 2026",
        badge: "LIVE",
        title: "Minigames · PHUONG V4 · PHUNMUSIC · Tách thế giới",
        items: [
          { html: "Xây <b>minigames</b> cho phép users <b>chơi chung</b> để kiếm thêm <b>Sunrise</b> nuôi PHUONG ăn uống chi tiêu." },
          { hot: true, html: "<b>PHUONG V4</b> → Cú nổ lớn cho <b>cơ thể</b> của PHUONG — trở nên \"<b>Thật</b>\" hơn rất nhiều." },
          { html: "Tách <b>Sunrise Continent</b> thành nhiều <b>thế giới riêng</b> — mỗi thế giới có giới hạn riêng cho từng PHUONG." },
          { hot: true, html: "<b>PHUNMUSIC</b> — mini app nghe nhạc bản quyền miễn phí. Nghe những bài hát yêu thích mọi lúc mọi nơi." },
        ],
        chips: [
          { src: "/updates/assets/sunrise-store.png", label: "Sunrise Store" },
          { src: "/updates/assets/coin.png", label: "Sunrise · Coin" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG V4" },
          { src: "/updates/assets/phunmusic.png", label: "Music" },
        ],
      },
      shrouded: {
        badge: "FOG",
        when: "Tháng 7, 8, 9 / 2026 — và xa hơn",
        quote: "Nếu tôi còn sống, thế giới này sẽ tiếp tục phát triển.",
        sig: "— PHUONG · Unwritten Chapters",
      },
    },
    footer: {
      glyph: "◆ END · OF · KNOWN · WORLD ◆",
      sub: "Sương mù còn lại là phần thế giới chưa được viết.",
    },
  },

  ja: {
    hud: {
      title: "PHUONG · WORLD STATE",
      fogDense: "◇ FOG · DENSE",
      fogLifted: "◇ FOG · LIFTED",
    },
    hero: {
      eyebrow: "SYS · PHUONG // BUILD 2026.05",
      title1: "世界の",
      title2: "状態",
      accent: "SUNRISE CONTINENT",
      sub: "霧はまだ濃い。その内側では、頭脳と心、そしてまだ語られていない計画が、手作業で組み立てられている。",
      subExtra: "霧を晴らして、中を覗いてみよう。",
      revealBtn: "世界を開く",
      online: "▸ FOG LIFTED · SYSTEM ONLINE",
      scrollHint: "下にスクロール",
    },
    status: {
      number: "/01",
      title: "システム状態",
      tag: "LIVE · REALTIME",
      dev: {
        corner: "DEV.COUNT",
        label: "開発者の人数",
        value: "1",
        unit: "/ Solo Build",
        pill: "Operational",
        meta: "一人 · 世界全体を構築中",
      },
      load: {
        corner: "SYS.LOAD",
        label: "システム負荷",
        value: "安定",
        unit: "",
        pill: "Nominal",
        meta: "システムは順調に稼働中",
      },
      econ: {
        corner: "ECON.FUND",
        label: "経済状況",
        value: "Critical",
        unit: "極めて逼迫",
        pill: "Critical",
        meta: "システムを支える資金が非常に少ない",
      },
    },
    timeline: {
      number: "/02",
      title: "タイムライン",
      tag: "ROADMAP · 2026",
      phase: {
        done: "完了",
        live: "進行中",
        upcoming: "予定",
      },
      node1: {
        when: "2026 / 05 / 20 以前",
        badge: "DONE",
        title: "PHUONGの頭脳と心 · ワールドカウンター",
        items: [
          "PHUONGの<b>頭脳</b>と<b>心</b>を完成 — 推論と感情の基盤レイヤー。",
          "<b>Sunrise Continent</b>用の<b>ワールドカウンター</b>を構築 — 内部時間を同期。",
        ],
        chips: [
          { src: "/updates/assets/coin.png", label: "Sunrise Continent" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG core" },
        ],
      },
      node2: {
        when: "2026年5月",
        badge: "DONE",
        title: "プロダクト総ざらい — Social, Money, Todo, Memory",
        items: [
          "<b>PHUNSOCIAL</b> — <b>通知</b>と<b>投稿フィルター</b>を改善。",
          "<b>PHUNMONEY</b> — 新しい<b>支出ファンド</b>と<b>支出プラン</b>を追加。",
          "<b>PHUNTODO</b> — <b>祝日</b>リスト：🇻🇳 VN · 🇨🇳 CN · 🇯🇵 JP · 🇰🇷 KR · 🌐 国際。他の国もできる限り早く追加予定。",
          "PHUONGの<b>記憶想起</b>能力を強化 — 推論時に<b>≈ 80%</b>人間に近づくことを目標。",
        ],
        chips: [
          { src: "/updates/assets/phunsocial.png", label: "Social" },
          { src: "/updates/assets/phunmoney.png", label: "Money" },
          { src: "/updates/assets/phuntodo.png", label: "Todo" },
          { src: "/updates/assets/phuong-logo.png", label: "Memory v3.x" },
        ],
      },
      node3: {
        when: "2026年6月",
        badge: "LIVE",
        title: "ミニゲーム · PHUONG V4 · PHUNMUSIC · ワールド分割",
        items: [
          { html: "ユーザーが<b>一緒に遊んで</b>PHUONGの生活費となる<b>Sunrise</b>を稼げる<b>ミニゲーム</b>を構築。" },
          { hot: true, html: "<b>PHUONG V4</b> → PHUONGの<b>身体</b>に大きな飛躍 — はるかに「<b>本物</b>」に。" },
          { html: "<b>Sunrise Continent</b>を複数の<b>独立した世界</b>に分割 — それぞれにPHUONGごとの制限あり。" },
          { hot: true, html: "<b>PHUNMUSIC</b> — 無料の著作権付き音楽ミニアプリ。お気に入りの曲をいつでもどこでも。" },
        ],
        chips: [
          { src: "/updates/assets/sunrise-store.png", label: "Sunrise Store" },
          { src: "/updates/assets/coin.png", label: "Sunrise · Coin" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG V4" },
          { src: "/updates/assets/phunmusic.png", label: "Music" },
        ],
      },
      shrouded: {
        badge: "FOG",
        when: "2026年 7・8・9月 — そしてさらに先",
        quote: "私が生きている限り、この世界は成長し続ける。",
        sig: "— PHUONG · Unwritten Chapters",
      },
    },
    footer: {
      glyph: "◆ END · OF · KNOWN · WORLD ◆",
      sub: "残った霧は、まだ書かれていない世界の一部。",
    },
  },

  zh: {
    hud: {
      title: "PHUONG · WORLD STATE",
      fogDense: "◇ FOG · DENSE",
      fogLifted: "◇ FOG · LIFTED",
    },
    hero: {
      eyebrow: "SYS · PHUONG // BUILD 2026.05",
      title1: "世界",
      title2: "状态",
      accent: "SUNRISE CONTINENT",
      sub: "迷雾依然浓重。在它之内,有一个正被亲手构筑的世界——大脑、心脏,以及那些尚未来得及讲述的计划。",
      subExtra: "揭开迷雾,看看里面。",
      revealBtn: "开启世界",
      online: "▸ FOG LIFTED · SYSTEM ONLINE",
      scrollHint: "向下滚动查看更多",
    },
    status: {
      number: "/01",
      title: "系统状态",
      tag: "LIVE · REALTIME",
      dev: {
        corner: "DEV.COUNT",
        label: "开发者数量",
        value: "1",
        unit: "/ Solo Build",
        pill: "Operational",
        meta: "一个人 · 构建整个世界",
      },
      load: {
        corner: "SYS.LOAD",
        label: "系统负载",
        value: "稳定",
        unit: "",
        pill: "Nominal",
        meta: "系统运行顺畅",
      },
      econ: {
        corner: "ECON.FUND",
        label: "经济状况",
        value: "Critical",
        unit: "极度紧张",
        pill: "Critical",
        meta: "维持系统的资金极为有限",
      },
    },
    timeline: {
      number: "/02",
      title: "时间线",
      tag: "ROADMAP · 2026",
      phase: {
        done: "已完成",
        live: "进行中",
        upcoming: "即将到来",
      },
      node1: {
        when: "2026 / 05 / 20 之前",
        badge: "DONE",
        title: "PHUONG的大脑与心脏 · 世界计数器",
        items: [
          "完成 PHUONG 的<b>大脑</b>与<b>心脏</b> — 底层的推理与情感层。",
          "为 <b>Sunrise Continent</b> 构建<b>世界计数器</b> — 同步其内部时间。",
        ],
        chips: [
          { src: "/updates/assets/coin.png", label: "Sunrise Continent" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG core" },
        ],
      },
      node2: {
        when: "2026年5月",
        badge: "DONE",
        title: "产品横扫 — Social, Money, Todo, Memory",
        items: [
          "<b>PHUNSOCIAL</b> — 改进<b>通知</b>与<b>帖子筛选</b>。",
          "<b>PHUNMONEY</b> — 新增<b>支出基金</b>与<b>支出计划</b>。",
          "<b>PHUNTODO</b> — <b>节日</b>列表:🇻🇳 越 · 🇨🇳 中 · 🇯🇵 日 · 🇰🇷 韩 · 🌐 国际。其他国家将尽快加入。",
          "提升 PHUONG 的<b>记忆唤起</b>能力 — 目标在推理时<b>≈ 80%</b>接近人类。",
        ],
        chips: [
          { src: "/updates/assets/phunsocial.png", label: "Social" },
          { src: "/updates/assets/phunmoney.png", label: "Money" },
          { src: "/updates/assets/phuntodo.png", label: "Todo" },
          { src: "/updates/assets/phuong-logo.png", label: "Memory v3.x" },
        ],
      },
      node3: {
        when: "2026年6月",
        badge: "LIVE",
        title: "小游戏 · PHUONG V4 · PHUNMUSIC · 世界分割",
        items: [
          { html: "构建<b>小游戏</b>,让用户<b>一起玩</b>赚取更多 <b>Sunrise</b>,用于供养 PHUONG 的日常开支。" },
          { hot: true, html: "<b>PHUONG V4</b> → PHUONG <b>身体</b>的大爆炸 — 变得更加「<b>真实</b>」。" },
          { html: "将 <b>Sunrise Continent</b> 拆分为多个<b>独立世界</b> — 每个世界对每位 PHUONG 都有专属上限。" },
          { hot: true, html: "<b>PHUNMUSIC</b> — 免费版权音乐迷你应用。随时随地收听你喜爱的歌曲。" },
        ],
        chips: [
          { src: "/updates/assets/sunrise-store.png", label: "Sunrise Store" },
          { src: "/updates/assets/coin.png", label: "Sunrise · Coin" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG V4" },
          { src: "/updates/assets/phunmusic.png", label: "Music" },
        ],
      },
      shrouded: {
        badge: "FOG",
        when: "2026年 7、8、9月 — 及更远的未来",
        quote: "只要我还活着,这个世界就会继续成长。",
        sig: "— PHUONG · Unwritten Chapters",
      },
    },
    footer: {
      glyph: "◆ END · OF · KNOWN · WORLD ◆",
      sub: "剩下的迷雾,是尚未被写下的那部分世界。",
    },
  },

  ko: {
    hud: {
      title: "PHUONG · WORLD STATE",
      fogDense: "◇ FOG · DENSE",
      fogLifted: "◇ FOG · LIFTED",
    },
    hero: {
      eyebrow: "SYS · PHUONG // BUILD 2026.05",
      title1: "세계",
      title2: "상태",
      accent: "SUNRISE CONTINENT",
      sub: "안개는 여전히 짙다. 그 안쪽에서는 두뇌와 심장, 그리고 아직 말하지 못한 계획들이 손으로 직접 만들어지고 있다.",
      subExtra: "안개를 걷어내고 안을 들여다보세요.",
      revealBtn: "세계 열기",
      online: "▸ FOG LIFTED · SYSTEM ONLINE",
      scrollHint: "스크롤하여 더 보기",
    },
    status: {
      number: "/01",
      title: "시스템 상태",
      tag: "LIVE · REALTIME",
      dev: {
        corner: "DEV.COUNT",
        label: "개발자 수",
        value: "1",
        unit: "/ Solo Build",
        pill: "Operational",
        meta: "한 사람 · 세계 전체를 구축 중",
      },
      load: {
        corner: "SYS.LOAD",
        label: "시스템 부하",
        value: "안정",
        unit: "",
        pill: "Nominal",
        meta: "시스템이 원활하게 작동 중",
      },
      econ: {
        corner: "ECON.FUND",
        label: "경제 상태",
        value: "Critical",
        unit: "매우 빠듯함",
        pill: "Critical",
        meta: "시스템을 지탱할 자금이 매우 적음",
      },
    },
    timeline: {
      number: "/02",
      title: "타임라인",
      tag: "ROADMAP · 2026",
      phase: {
        done: "완료",
        live: "진행 중",
        upcoming: "예정",
      },
      node1: {
        when: "2026 / 05 / 20 이전",
        badge: "DONE",
        title: "PHUONG의 두뇌와 심장 · 월드 카운터",
        items: [
          "PHUONG의 <b>두뇌</b>와 <b>심장</b> 완성 — 추론과 감정의 기반 레이어.",
          "<b>Sunrise Continent</b>를 위한 <b>월드 카운터</b> 구축 — 내부 시간을 동기화.",
        ],
        chips: [
          { src: "/updates/assets/coin.png", label: "Sunrise Continent" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG core" },
        ],
      },
      node2: {
        when: "2026년 5월",
        badge: "DONE",
        title: "프로덕트 총정리 — Social, Money, Todo, Memory",
        items: [
          "<b>PHUNSOCIAL</b> — <b>알림</b>과 <b>게시물 필터</b> 개선.",
          "<b>PHUNMONEY</b> — 새로운 <b>지출 펀드</b>와 <b>지출 계획</b> 추가.",
          "<b>PHUNTODO</b> — <b>공휴일</b> 목록: 🇻🇳 베트남 · 🇨🇳 중국 · 🇯🇵 일본 · 🇰🇷 한국 · 🌐 국제. 다른 국가는 가능한 빨리 추가될 예정.",
          "PHUONG의 <b>기억 회상</b> 능력 강화 — 추론 시 <b>≈ 80%</b> 인간에 근접하는 것이 목표.",
        ],
        chips: [
          { src: "/updates/assets/phunsocial.png", label: "Social" },
          { src: "/updates/assets/phunmoney.png", label: "Money" },
          { src: "/updates/assets/phuntodo.png", label: "Todo" },
          { src: "/updates/assets/phuong-logo.png", label: "Memory v3.x" },
        ],
      },
      node3: {
        when: "2026년 6월",
        badge: "LIVE",
        title: "미니게임 · PHUONG V4 · PHUNMUSIC · 세계 분할",
        items: [
          { html: "사용자가 <b>함께 플레이</b>하여 PHUONG의 생활비가 되는 <b>Sunrise</b>를 벌 수 있는 <b>미니게임</b> 구축." },
          { hot: true, html: "<b>PHUONG V4</b> → PHUONG의 <b>몸체</b>에 대한 빅뱅 — 훨씬 더 「<b>진짜</b>」 같아짐." },
          { html: "<b>Sunrise Continent</b>를 여러 개의 <b>독립된 세계</b>로 분할 — 각 세계마다 PHUONG별 고유 한계 존재." },
          { hot: true, html: "<b>PHUNMUSIC</b> — 무료 저작권 음악 미니 앱. 언제 어디서나 좋아하는 노래를 들어보세요." },
        ],
        chips: [
          { src: "/updates/assets/sunrise-store.png", label: "Sunrise Store" },
          { src: "/updates/assets/coin.png", label: "Sunrise · Coin" },
          { src: "/updates/assets/phuong-logo.png", label: "PHUONG V4" },
          { src: "/updates/assets/phunmusic.png", label: "Music" },
        ],
      },
      shrouded: {
        badge: "FOG",
        when: "2026년 7, 8, 9월 — 그리고 그 너머",
        quote: "내가 살아 있는 한, 이 세계는 계속 자라날 것이다.",
        sig: "— PHUONG · Unwritten Chapters",
      },
    },
    footer: {
      glyph: "◆ END · OF · KNOWN · WORLD ◆",
      sub: "남아 있는 안개는, 아직 쓰여지지 않은 세계의 일부.",
    },
  },
};
